// extracted by mini-css-extract-plugin
export default {"container":"IF-z","vocBtn":"JF-z","disabled":"KF-z"};